/* eslint-disable max-len */
import React from 'react'

export const Warning = () => (
  (<>
    <svg width="45" height="39" viewBox="0 0 45 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M44.3548 35.5604L24.4869 1.14527C24.0774 0.436114 23.3189 0 22.4998 0C21.6806 0 20.9222 0.436114 20.5126 1.14527L0.644762 35.5604C0.235193 36.2695 0.235193 37.1456 0.644762 37.8547C1.05433 38.5639 1.81279 39 2.63193 39H42.3714C43.1906 39 43.949 38.5639 44.3586 37.8547C44.7644 37.1418 44.7644 36.2695 44.3548 35.5604ZM6.60626 34.4113L22.4998 6.87923L38.3933 34.4113H6.60626Z" fill="#AA1E1E"/>
      <path d="M24.1267 28.5031C23.6906 28.1163 23.1521 27.9229 22.4998 27.9229C21.8513 27.9229 21.309 28.1163 20.8729 28.5031C20.4368 28.8899 20.2206 29.3829 20.2206 29.9821C20.2206 30.5813 20.4368 31.0743 20.8729 31.4611C21.3052 31.8479 21.8475 32.0413 22.4998 32.0413C23.1483 32.0413 23.6906 31.8479 24.1267 31.4611C24.559 31.0743 24.779 30.5813 24.779 29.9821C24.7752 29.3791 24.559 28.8861 24.1267 28.5031Z" fill="#AA1E1E"/>
      <path d="M20.869 26.2082H24.1911L24.7144 14.0918H20.3457L20.869 26.2082Z" fill="#AA1E1E"/>
    </svg>

  </>)
)
